import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
import commonComponents from '../src/components/index.js';
import App from './App.vue';
import router from './router';
import mixins from "./mixins/index.js";

import VueQuillEditor from 'vue-quill-editor'
 
// 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
 
Vue.use(VueQuillEditor, /* { 默认全局 } */)

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(commonComponents); // 注册自己的组件
Vue.mixin(mixins);
Vue.prototype.$eventBus = new Vue()

import * as util from './utils/index';
Vue.prototype.$addThousandSeparator = util.addThousandSeparator;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
